import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  Grid,
  IconButton,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import { Instagram } from "@mui/icons-material";

import Cris from "../assets/img/vereadoresImg/cris.png"
import Erivan from "../assets/img/vereadoresImg/erivan.png"
import Edilmo from "../assets/img/vereadoresImg/edilmo.png"
import Jailson from "../assets/img/vereadoresImg/jailson.png"
import Janaina from "../assets/img/vereadoresImg/janaina.png"
import Leandro from "../assets/img/vereadoresImg/leandro.png"
import Marcia from "../assets/img/vereadoresImg/marcia.png"
import Ovidio from "../assets/img/vereadoresImg/ovidio.png"
import Wagner from "../assets/img/vereadoresImg/wagner.png"

const MesaDiretora = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: { xs: 2, sm: 4 },
        width: "100%",
        margin: "0 auto",
        boxSizing: "border-box",
        [theme.breakpoints.up("md")]: {
          width: "70%",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          padding: 2,
          borderRadius: 1,
          width: "100%",
          maxWidth: 900,
          textAlign: "center",
          marginBottom: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          MESA DIRETORA
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: 900, width: "100%" }}>
        {[{ nome: "Cristilene Bezerra de Azevedo", cargo: "PRESIDENTE (A)", avatar: Cris, instagram: "https://www.instagram.com/crisazevedo313/" },
        { nome: "Ovidio de Aquino e Silva Neto", cargo: "VICE-PRESIDENTE (A)", avatar: Ovidio, instagram: "https://www.instagram.com/vereadortabelinho45666/" },
        { nome: "Janaina Patrícia Bezerra da Silva", cargo: "1 SECRETARIO(A)", avatar: Janaina, instagram: "https://www.instagram.com/janainabezerra.rn?igsh=eTBxOHViN3VzcTNz" },
        { nome: "Erivan Elias da Silva", cargo: "2 SECRETARIO(A)", avatar: Erivan, instagram: "https://www.instagram.com/vereadorerivanelias" },
        { nome: "Edilmo Lira", cargo: "SUPLENTE", avatar: Edilmo, instagram: "https://www.instagram.com/edilmo_lira/" }
        ].map((pessoa, index) => (
          <Grid item xs={12} key={index}>
            <Card sx={{ borderRadius: 2 }}>
              <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  src={pessoa.avatar}
                  alt={pessoa.nome}
                  sx={{ width: 64, height: 64, marginRight: 2 }}
                />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
                    {pessoa.nome}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.875rem", color: "text.secondary" }}
                  >
                    {pessoa.cargo}
                  </Typography>
                </Box>
              </CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: 2,
                  paddingBottom: 1,
                }}
              >
                <IconButton color="secondary" href={pessoa.instagram}>
                  <Instagram />
                </IconButton>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>


      <Divider sx={{ marginY: 4, width: "100%", maxWidth: 900 }} />

      <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: "bold", textAlign: "center" }}>
        Gestores anteriores
      </Typography>
      <TableContainer component={Paper} sx={{ borderRadius: 2, maxWidth: 900, width: "100%" }}>
        <Table>
          <TableBody>
            <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
              <TableCell sx={{ fontWeight: "bold" }}>Data início</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Data fim</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Nome</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Cargo</TableCell>
            </TableRow>
            {[
              { inicio: "01/01/2024", fim: "31/12/2024", nome: "FRANCISCO VICENTE JUNIOR", cargo: "PRESIDENTE(A)" },
              { inicio: "01/01/2023", fim: "31/12/2023", nome: "ERIVAN ELIAS DA SILVA", cargo: "PRESIDENTE(A)" },
              { inicio: "01/01/2022", fim: "31/12/2022", nome: "EDILMO LIRA", cargo: "PRESIDENTE(A)" },
            ].map((gestor, index) => (
              <TableRow key={index}>
                <TableCell>{gestor.inicio}</TableCell>
                <TableCell>{gestor.fim}</TableCell>
                <TableCell sx={{ textTransform: "uppercase" }}>{gestor.nome}</TableCell>
                <TableCell sx={{ textTransform: "uppercase" }}>{gestor.cargo}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MesaDiretora;
